module.exports = __webpack_public_path__ + "img/icon_pie_chart.1de3b965.svg";